import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Boxhourglass from'../images/box_hourglass.png';

const Snackbar = forwardRef(({ 
  snackbarState,  
  notifications,
  minimizeSnackbar, 
  expandSnackbar, 
  hideSnackbar, 
  customStyle = {},
  onVisibilityChange 
}, ref) => {
  const navigate = useNavigate();
  const [snackbarQuotes, setSnackbarQuotes] = useState([]);
  const url = process.env.REACT_APP_FORE_BRICKBUCKET; 
  const [userData, setUserData] = useState(null);
  //console.log("----userData:------",userData);
  const [fetchedNotifications, setFetchedNotifications] = useState([]);
  const [latestNotification, setLatestNotification] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  // Expose quotes to parent component
  useImperativeHandle(ref, () => ({
    quotes: snackbarQuotes
  }));

  useEffect(() => {
    const userDetails = JSON.parse(sessionStorage.getItem('userData')) || JSON.parse(localStorage.getItem('userData'));
  setUserData(userDetails);
  }, []);

    useEffect(() => {
        if (userData) {
            //console.log('Calling fetchOrderNotifications for user:', userData._id);
            fetchOrderNotifications();
        }
    }, [userData]);

  // Update the fetchOrderNotifications function (same pattern as OrderDetails.js)
    const fetchOrderNotifications = async () => {
        try {
            const userData = JSON.parse(sessionStorage.getItem('userData'));
            const userId = userData?._id;
            const token = userData?.token || sessionStorage.getItem('token');
            
            if (!userId) {
                console.log('No userId found');
                return;
            }

            const response = await fetch(
                `${url}customer/quotations/get-consumer-live-order-notifications?userId=${userId}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-token': token,
                    },
                }
            );

            const data = await response.json();
            console.log('Fetched order notifications:', data);
            
            if (data.success && data.data) {
                setFetchedNotifications(data.data);
            }
        } catch (error) {
            console.error('Error fetching order notifications:', error);
        }
    };


        // Update latestNotification when new real-time notifications arrive
        useEffect(() => {
            if (notifications && notifications.length > 0) {
                console.log('New notifications received:', notifications);
                // Replace the previous latestNotification with the latest real-time notification
                setLatestNotification(notifications[notifications.length - 1]);
            }
        }, [notifications]);
    
            // Initialize latestNotification with fetchedNotifications[0].metadata
        useEffect(() => {
            if (fetchedNotifications && fetchedNotifications.length > 0) {
                setLatestNotification({
                    data: fetchedNotifications[0].metadata
                });
            }
        }, [fetchedNotifications]);

 // New useEffect to track visibility and notify parent
  useEffect(() => {
    const shouldBeVisible = latestNotification && latestNotification.data;
    setIsVisible(shouldBeVisible);
    
    // Notify parent component about visibility change
    if (onVisibilityChange) {
      onVisibilityChange(shouldBeVisible);
    }
  }, [latestNotification, onVisibilityChange]);

   // Only render if visible
  if (!isVisible) {
    return null;
  }

  return (
       <div className="fixed left-1/2 transform -translate-x-1/2 bottom-20 z-10 shadow-lg transition-all duration-300 border border-[#E0D9D9] bg-white rounded-lg w-[95%] mx-auto">
                          <div className="relative flex items-center px-2">                       
                              {/* Main content - Latest notification */}
                              <div
                                  className="space-x-2 flex items-center w-full mt-2 cursor-pointer hover:bg-gray-50 rounded-lg p-2 transition-all duration-300"
                                  onClick={() => {
                                      const orderId = latestNotification?.data?.order_id;
                                      const cleanOrderId = orderId?.replace(/"/g, '');
                                      
                                      navigate(`/consumer/app/orderdetails`, {
                                          state: {
                                              quotationId: cleanOrderId
                                          }
                                      });
                                  }}
                              >
                                  {/* Box hourglass Icon */}
                                  <div className="relative mr-2">
                                      <div className="w-14 h-14 rounded-full flex items-center justify-center">
                                          <img src={Boxhourglass} alt="Order" className="text-base" />
                                      </div>
                                  </div>
                                  
                                  {/* Order Details */}
                                  <div className="flex-1 min-w-0">
                                      <div className='flex flex-row justify-start items-center gap-2'>
                                          <h4 className="text-sm font-medium text-black truncate leading-tight">
                                              #{latestNotification?.data?.order_number}
                                          </h4>
                                      </div>
                                      <p className="text-sm font-medium text-[#524D4D] truncate leading-tight">
                                          ₹{latestNotification?.data?.total_amount?.toLocaleString('en-IN') || '0'}
                                      </p>
                                      <p className="text-sm font-semibold text-[#524D4D] truncate leading-tight">
                                          {latestNotification?.data?.order_status}
                                      </p>
                                  </div>
                                  
                                  {/* Arrow */}
                                  <div className="flex-shrink-0">
                                      <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                      </svg>
                                  </div>
                              </div>
                          </div>
                      </div>
  );
});

export default Snackbar;
